import BaseController from "confinus_ui/base_controller";
// Import only core, import { Swiper } from "swiper"; seems to still bring
// into bundle all of swiper, not just Swiper core
// @ts-ignore
import Swiper from "swiper/core/core.js";

export default class CarouselController extends BaseController {
  public static values = {
    slidesPerView: Number,
  };

  declare private readonly slidesPerViewValue: any;
  private carousel?: Swiper = undefined;

  public connect() {
    super.connect();
    this.element.classList.remove("hidden");
    const perView = window.innerWidth > 600 ? 3 : 1.25;
    const desired = this.slidesPerViewValue;
    this.carousel = new Swiper(this.element as HTMLElement, {
      slidesPerView: desired ? this.slidesPerViewValue! : perView,
      centeredSlides: true,
      spaceBetween: 16,
    });
  }

  public disconnect() {
    if (this.carousel) {
      this.carousel.destroy();
      this.carousel = undefined;
    }
    super.disconnect();
  }

  public previous() {
    this.carousel!.slidePrev();
  }

  public next() {
    this.carousel!.slideNext();
  }
}
